import { z } from "zod";
import { InductionLocaleSchema } from "./induction-locale";
import {
  ContractorPortalSiteDetailSchema,
  ContractorPortalSiteDetailStrict,
} from "./portal";

/**
 * Wire shape for a translated site-induction view (issue #1082 — mobile
 * parity with the web gate/portal pickers). `siteDetails` is the full detail
 * list with translated values substituted for the translatable fields;
 * non-translatable entries (principal contractor, hospital) stay verbatim.
 */
export const InductionTranslationViewSchema = z.object({
  locale: InductionLocaleSchema,
  // AI = machine translation; BUILDER = reviewed/overridden by the site team.
  source: z.enum(["AI", "BUILDER"]),
  reviewedAt: z.string().datetime().nullable(),
  siteDetails: z.array(ContractorPortalSiteDetailSchema),
});

export type InductionTranslationView = z.infer<
  typeof InductionTranslationViewSchema
>;

/** Response of GET …/induction-translation — null when English/unavailable. */
export const InductionTranslationResponseSchema = z.object({
  translation: InductionTranslationViewSchema.nullable(),
});

// ─── #2411 server-boundary variants ─────────────────────────────────────────
// The contractor-side mobile app parses the permissive bases above; the
// portal induction-translation route serialises through these Strict forms.

export const InductionTranslationViewStrict =
  InductionTranslationViewSchema.extend({
    siteDetails: z.array(ContractorPortalSiteDetailStrict),
  }).strict();

export const InductionTranslationResponseStrict = z
  .object({
    translation: InductionTranslationViewStrict.nullable(),
  })
  .strict();

export type InductionTranslationResponse = z.infer<
  typeof InductionTranslationResponseSchema
>;
